import React from "react";
import FAQs from "./faqs";

const Disclaimer = (props) => {
  return (
    <div className="disclaimer">
      Internet usage is logged and subject to monitoring in accordance with
      <a
        id="policiesLink"
        href="https://mytrinityhealth.sharepoint.com/sites/SO-TISEIS/SitePages/Policies-&amp;-Procedures.aspx"
        target="_blank"
      >
        Trinity Health Policy
      </a>{" "}
      |{" "}
      <a
        className="faq"
        href="https://mytrinityhealth.sharepoint.com/sites/SO-TISEIS/SitePages/Blocking-Risky-Websites.aspx"
        target="_blank"
      >
        Frequently Asked Questions
      </a>
    </div>
  );
};

export default Disclaimer;
